/* 
    This is the site map 

    Pages are different but map component gets boolean for wheter or not to have live pig displayed
    
    Site Map with pig will need the polling hook attached to it to get continuous updates from the backend
        -As new data comes in map component itself shouldn't be rerendered but the data inside map component will adjust itself
        
*/
import MapComponent from "../components/maps/MapComponent";
import Select from 'react-select';
import useJobOptions from '../hooks/useJobOptions';
import useRunOptions from '../hooks/useRunOptions';
import { useEffect, useState } from 'react';
import { MapControlProvider } from "../contexts/MapControlContext";
import { PageHeader } from "../components/ui/layout/PageHeader";
import { PageContainer } from "../components/ui/layout/PageContainer";
import Label from "../components/ui/labels/Label"
import { SelectContainer } from "../components/ui/layout/SelectContainer";
import { useUser } from "@contexts/UserContext";
import { fetchJobData } from "@utils/jobs/fetchJobData";
import { useError } from "@contexts/ErrorContext";

/**
 * Live map that shows the pipeline with AGMs, Subchains, and POIs for a job, and the PIG moving down the line in real time.
 * 
 * @returns {JSX.Element}
 * 
 * @category Pages
 */
export const SiteMapWPig = () => {
    const { jobNameOptions } = useJobOptions();
    const { runNameOptions, fetchRuns, clearRuns } = useRunOptions();
    const [selectedJob, setSelectedJob] = useState(null);
    const [selectedRun, setSelectedRun] = useState(null);
    const [gglKey, setGglKey] = useState(1);
    const {storedJob, setStoredJob, userPermissions} = useUser();
    const {showError} = useError();

    const hasJobPermissions = userPermissions.jobs.create && userPermissions.jobs.update

    const handleJobSelected = (job) => {
        clearRuns();
        fetchJobData(job, showError, setSelectedJob, setStoredJob);
    }

    const handleRunSelected = (run) => {
        setSelectedRun(run);
    }

    useEffect(() => {
        if (selectedJob) {
            setSelectedRun(null)
            setGglKey(gglKey + 1)
            fetchRuns(selectedJob.value.toString());
        }
    }, [selectedJob]); //eslint-disable-line


    useEffect(() => {
        document.title = `MarTrak - Site Map w/ Pig`

        //if a job was previously selected and added to UserContext, pull it in here
        if(storedJob){
            fetchJobData(storedJob, showError, setSelectedJob, setStoredJob)
        }

    }, []); //eslint-disable-line

    return (
        <>
            <PageHeader pageTitle="Site Map w/ PIG" />

            <PageContainer>

                <Label htmlFor='job-select'>Select A Job</Label>

                <SelectContainer>
                    <Select
                        name='job-select'
                        options={jobNameOptions}
                        onChange={handleJobSelected}
                        value={selectedJob}
                    />
                </SelectContainer>

                <Label htmlFor='run-select'>Select A Run</Label>

                <SelectContainer>
                    <Select
                        name='run-select'
                        options={runNameOptions}
                        onChange={handleRunSelected}
                    />
                </SelectContainer>
            </PageContainer>

            {/* to show map, must have selected job, run, and job must be locked (set-up complete) */}
            {selectedJob ? (
                //don't include IsLocked === null in check - we don't want to prevent viewing of old jobs with no 'locked' property
                selectedJob.IsLocked === false ? (
                    <div className="flex justify-center mt-10">
                        <p className='text-purple-600 font-bold italic'>
                            {hasJobPermissions ? 
                            'Job is unlocked. To view this page, go to Job Details and lock the job.' : 
                            'Job is still being set up. Please check back later.'}
                        </p>
                    </div>
                ) : selectedRun ? (
                    <div className="mb-20">
                        <hr style={{ margin: "0 var(--left-right-margin) 1rem" }} />
                        <MapControlProvider>
                            <MapComponent
                                key={gglKey}
                                selectedJob={selectedJob}
                                selectedRun={selectedRun}
                                poiMap
                                liveWPig
                                timezone={selectedJob.timezone}
                            />
                        </MapControlProvider>
                    </div>
                ) : null
            ) : null}

        </>
    )
}